export const VINTAGE_SHOP_PRODUCT_CONTENT_TYPE = 'vintageShopProduct'
export const VINTAGE_SHOP_HERO_BLOCK = 'vintageShopHero'
export const VINTAGE_SHOP_FOOTER_BLOCK = 'vintageShopFooter'
export const VINTAGE_SHOP_PRODUCT_LIST_BLOCK = 'vintageShopProductList'
